/**
 * @Author: Zewei
 * @Date:   2018-01-22T10:41:43+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-07T17:42:19+08:00
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchRoleList, addRoleInit, createNewRole, deleteRoles, fetchRoleDetail, hiddenAsyncModal, updateRole } from '../../actions/system-setting-actions.js';
import { Table, Button, Spin, Modal, message } from 'antd';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import RoleAddModal from '../../components/SystemSetting/RoleAddModal.js';
import RoleEditModal from '../../components/SystemSetting/RoleEditModal.js';
import './style.less';

const defaultCheckedList = ['创建', '删除', '查看', '修改'];

let newRolePrmissions = [];

const mapStateToProps = state => ({systemSetting: state.systemSetting});
const mapDispatchToProps = { fetchRoleList, addRoleInit, createNewRole, deleteRoles, fetchRoleDetail, hiddenAsyncModal, updateRole };

@connect(mapStateToProps, mapDispatchToProps)
class RoleManagement extends Component {
     constructor(props){
     	super(props);
        this.columns = [{
          title: '名称',
          dataIndex: 'name',
          key: 'name',
        }, {
          title: '等级',
          dataIndex: 'level',
          key: 'level',
        }, {
          title: '部门',
          dataIndex: 'department',
          key: 'department',
        }, {
          title: '职能',
          dataIndex: 'competency',
          key: 'competency',
        }, {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          render: (text, record) => this.props.access.roleManagement.u_value && 
            <span onClick={this.handleShowModal.bind(this, record)}>
                <Button icon="edit" size="small" className="row-action-btn">编辑</Button>
                {/*<Icon type="edit" className="icon-hover-pointer"  />*/}
            </span>
          
        }];
     }

     state = {
       modalVisible: false,
       permissions: [],
       username: '',
       isEditable: false,
       checkedList: defaultCheckedList,
       selectedRowKeys: [], // Check here to configure the default column
       // innerSelectedRowKeys: [],
     }

     componentDidMount() {
         this._fetchRoleList()
         this._addRoleInit()
     }
     componentWillReceiveProps(nextProps) {
      console.log(nextProps);
         let { systemSetting } = nextProps;
         systemSetting.actionStatus && this._fetchRoleList();
     }
     _fetchRoleList = (params) => {
         this.props.fetchRoleList(params)
     }
     _addRoleInit = () => {
         this.props.addRoleInit();
     }
     handleShowModal = (param) => {
         let isEditable, requestParam;

         if (param.id) {
             isEditable = true;
             requestParam = {
                 modelId: param.id
             }
             this.props.fetchRoleDetail(requestParam)
         } else {
             isEditable = false;
             this.setState({
                 modalVisible: true,
             });
         }

         this.setState({
             isEditable
         })
     }

     handleDeleteSelected = () => {
      if (this.state.selectedRowKeys.length > 0) {
        Modal.confirm({
          title: '确定删除?',
          okText: '确认',
          cancelText: '取消',
          onOk: () => {
         let params = {ids: this.state.selectedRowKeys};
         this.props.deleteRoles(params);
          },
          onCancel: () => {}
        });
      } else {
        message.error('请选择角色',4);
      }
     }

     handleCreateNewRole = (e) => {
       let { name, department, level, competency, permissions } = this.state;
       if (name && department && level && competency) {
           let payload = {
               name: name,
               department: department,
               level: level,
               competency: competency,
               permissions: permissions,
               // organization_id: 1,
               // parent_id: 1,
               // status: 1,
               // sequence: 1,
           }
           this.props.createNewRole(payload);
           // 提交后 总是 将 新角色权限 重置为 空数组
           newRolePrmissions = [];
           this.setState({
             modalVisible: false,
             permissions: [], // 提交后 当前权限 重置为 空数组
           });
       } else {
           return
       }
     }

     handleEditRole = (childPermissions) => {
         console.log(childPermissions)
         const state = this.state;
         const { roleDetail } = this.props.systemSetting;

         let name = state.name ? state.name : roleDetail.name,
             department = state.department ? state.department : roleDetail.department,
             level = state.level ? state.level : roleDetail.level,
             competency = state.competency ? state.competency : roleDetail.competency,
             id = roleDetail.id;

         if (name && department && level && competency && id) {
             // console.log(newRolePrmissions)
             newRolePrmissions.forEach((item, idx) => {
              console.log(item)
                 childPermissions.forEach((i) => {
                     if (i['module_id'] === item['module_id']) {
                         if (item['c_value'] !== undefined) {
                             i['c_value'] = item['c_value']
                         } else if (item['u_value'] !== undefined) {
                             i['u_value'] = item['u_value']
                         } else if (item['r_value'] !== undefined) {
                             i['r_value'] = item['r_value']
                         } else if (item['d_value'] !== undefined) {
                             i['d_value'] = item['d_value']
                         }
                         // i['c_value'] = item['c_value'];
                         // i['u_value'] = item['u_value'];
                         // i['r_value'] = item['r_value'];
                         // i['d_value'] = item['d_value'];
                         newRolePrmissions.splice(idx, 1)
                     }
                 })
             });

             let payload = {
                     name,
                     department,
                     level,
                     competency,
                     id,
                     permissions: newRolePrmissions.concat(childPermissions)
                     // organization_id: 1,
                     // parent_id: 1,
                     // status: 1,
                     // sequence: 1,
                 };
             console.log('payload Prmissions >>>', payload.permissions)
             // payload.Permissions.forEach((permission, index) => {

             // });
             this.props.updateRole(payload);
             newRolePrmissions = [];
         } else {
             return
         }
     }

     handleCancel = (e) => {
       this.setState({
         modalVisible: false,
       });
       newRolePrmissions = [];
     }
     asyncHandleCancel = () => {
         this.props.hiddenAsyncModal();
         newRolePrmissions = [];
     }

     onSelectChange = (selectedRowKeys, selectedRows) => {
         this.setState({ selectedRowKeys });
     }

     // onInnerSelectChange = (record) => {
     //     console.log('selectedRowKeys changed: ', record);
     //     this.setState({ innerSelectedRowKeys });
     // }

     handleInputChange = (param, e) => {
       e.preventDefault();
       e.stopPropagation()
       this.setState({
         [param]: e.target.value
       })
     }
     // param 为bind时传入参数， val 为 所选option的 key值
     handleSelectChange = (param, val) => {
       this.setState({
         [param]: val
       })
     }

     onCheckboxChange = (record, authName, e) => {
       // console.log(record)
       let target = e.target,
           selectedRowPermission = {};// 当前选取的table row 的角色权限， 每行初始值始终为一个空对象

       // 每次创建 新角色权限/newRolePrmissions 时 初始值 总是一个空数组
       let res = newRolePrmissions.find((i) => {
           return i['module_id'] === record.id;
       })
       // 该新角色权限数组中是否存在 当前选中的 行(根据id值 判断 ); 存在的话 将该 authName 值设为 当前的 target.checked | true/false; 不存在则push
       if (res) {
           res[authName] = target.checked;
       } else {
           pushNewPermission()
       }
       console.log('newRolePrmissions >', newRolePrmissions)
       function pushNewPermission() {
           selectedRowPermission['module_id'] = record.id;
           selectedRowPermission['module_name'] = record.name;
           selectedRowPermission[authName] = target.checked;
           newRolePrmissions.push(selectedRowPermission);
       }
       console.log(this.state)
       this.setState({
         permissions: newRolePrmissions,
       }, () => console.log(this.state))

       // newRolePrmissions = []

     }

     render() {
         const { roleList, initRole, roleDetail, asyncModalVisible } = this.props.systemSetting;
         const { selectedRowKeys, modalVisible } = this.state;
         const rowSelection = {
           selectedRowKeys,
           onChange: this.onSelectChange,
         };
         let paginationCfg;
         if (roleList) {
             paginationCfg = {
                 current: roleList.Page,
                 total: roleList.Total,
                 pageSize: roleList.PageSize,
                 onChange: (page) => {
                     this._fetchRoleList({page})
                 }
             }
         }

         return (
             <div className="app-module-item">
                 <div className="colAction">
                     {this.props.access.roleManagement.c_value && <Button icon="plus-circle-o" type="primary" onClick={this.handleShowModal} style={{marginRight: "10px"}}>新增</Button>}
                     {this.props.access.roleManagement.d_value && <Button icon="minus-circle-o" type="primary" onClick={this.handleDeleteSelected}>删除</Button>}
                 </div>
                 {
                   roleList ?
                     <Table
                         rowSelection={rowSelection}
                         columns={this.columns}
                         dataSource={roleList.Data}
                         rowKey={record => record.id}
                         pagination={paginationCfg}
                     />
                     :
                     <Spin className="spin-center" />
                 }

                 <RoleAddModal
                     modalVisible={modalVisible}
                     initRole={initRole}
                     onCancel={this.handleCancel}
                     handleCreateNewRole={this.handleCreateNewRole}
                     handleInputChange={this.handleInputChange}
                     handleSelectChange={this.handleSelectChange}
                     onCheckboxChange={this.onCheckboxChange}
                 />
                 {
                     roleDetail && roleDetail.permissions ?
                         <RoleEditModal
                             modalVisible={asyncModalVisible}
                             initRole={initRole}
                             onCancel={this.asyncHandleCancel}
                             handleInputChange={this.handleInputChange}
                             handleSelectChange={this.handleSelectChange}
                             onCheckboxChange={this.onCheckboxChange}
                             handleEditRole={this.handleEditRole}
                             roleDetail={roleDetail}
                         />
                         :
                         ''
                 }
             </div>
         )
     }
 }

RoleManagement = LayoutWrapper(RoleManagement);
export default RoleManagement;



// WEBPACK FOOTER //
// ./src/routes/SystemSetting/RoleManagement.js